import storage from '@drivesally/sally-fw/lib/storage/localStorage';

export default storage('/george/spotlight/last-hard-reset');
